import { requestService } from '../../framework/client/query_client';
import { HttpMethod } from '../../../common/framework/model/HttpMethod';
import { PurchaseInvoiceMappingResult } from '../../../common/application/api/service/mapping/PurchaseInvoiceMappingResult';
import { ApplicationServiceType } from '../../../common/application/enumeration/ApplicationServiceType';

export async function getPurchaseInvoiceMapping(purchaseInvoiceId: string): Promise<PurchaseInvoiceMappingResult> {
    return (await requestService<{}, {}, PurchaseInvoiceMappingResult>({
        method: HttpMethod.GET,
        resourceId: purchaseInvoiceId,
        type: ApplicationServiceType.PURCHASE_INVOICE_MAPPING,
    }))!!;

    // const response = await apiGet(`/api/service/${ApplicationServiceType.PURCHASE_INVOICE_MAPPING}`, { purchaseInvoiceId });
    // if (response.status === 200) {
    //     return (await response.json()) as PurchaseInvoiceMappingResult;
    // } else {
    //     throw new Error(ERROR_API_CALL_FAILED);
    // }
}
